import React, { useCallback, useEffect, useState } from "react";
import styles from "./Enach.module.css";
import SaveBtn from "../Buttons/SaveBtn";
import { IconButton, MenuItem, Popover, Tooltip } from "@mui/material";
import dots from "../../assets/images/unionDots.svg";
import CancelPaymentLinkPopup from "./EnachCancelPopup";
import EnachConfirmPopup from "./ENachConfirmPopup";
import { useSelector } from "react-redux";
import {
  cancelEnach,
  copyEnachLinkHit,
  deactivateEnach,
  getLeadListByInstituteAndContact,
  resendEnach,
  resetCancelEnachSuccess,
  resetCopyEnachLinkSuccess,
  resetDeActivateEnachSuccess,
  resetResendEnachSuccess,
} from "../../pages/app/Nurture/service/nurtureSlice";
import { useDispatch } from "react-redux";
import { useAuthUser } from "react-auth-kit";

const ENach = ({ leadById }: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [cancelPopup, setCancelPopup] = useState<boolean>(false);
  const [openEnachPopup, setOpenEnachPopup] = useState(false);
  const dispatch = useDispatch();
  const auth = useAuthUser();
  const authUser = auth();
  const [cancelPopupBeforeActivating, setCancelPopupBeforeActivating] =
    useState<boolean>(false);

  const open = Boolean(anchorEl);
  const {
    deactivateEnachSuccess,
    cancelEnachSuccess,
    resendEnachSuccess,
    copyEnachLinkSuccess,
    copyEnachLink,
  } = useSelector((state: any) => state.nurture);

  const handleSubmit = () => {
    setOpenEnachPopup(true);
  };

  const handleCancelOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCancelClose = () => {
    setAnchorEl(null);
  };

  const openCancelPopup = () => {
    setCancelPopup(true);
  };
  const closeCancelPopup = () => {
    setCancelPopup(false);
  };

  const cancelConfirm = () => {
    setCancelPopup(false);
    const body = {
      instituteId: authUser?.institute[0]?.instituteId,
      enquiryId: leadById?.id,
    };
    dispatch<any>(deactivateEnach(body));
  };

  useEffect(() => {
    if (deactivateEnachSuccess === true) {
      dispatch(resetDeActivateEnachSuccess());
      leadPopupApiCall(
        leadById?.instituteId,
        leadById?.studentContact,
        leadById?.studentEmail
      );
      closeCancelPopup();
    }
  }, [deactivateEnachSuccess]);

  useEffect(() => {
    if (
      cancelEnachSuccess === true ||
      resendEnachSuccess === true ||
      copyEnachLinkSuccess === true
    ) {
      dispatch(resetCancelEnachSuccess());
      dispatch(resetResendEnachSuccess());
      dispatch(resetCopyEnachLinkSuccess());
      leadPopupApiCall(
        leadById?.instituteId,
        leadById?.studentContact,
        leadById?.studentEmail
      );
      closeCancelPopup();
    }
  }, [cancelEnachSuccess, resendEnachSuccess, copyEnachLinkSuccess]);

  useEffect(() => {
    if (copyEnachLinkSuccess === true) {
      navigator.clipboard.writeText(copyEnachLink?.data);
      dispatch(resetCopyEnachLinkSuccess());
      leadPopupApiCall(
        leadById?.instituteId,
        leadById?.studentContact,
        leadById?.studentEmail
      );
      closeCancelPopup();
    }
  }, [copyEnachLinkSuccess]);

  const leadPopupApiCall = useCallback(
    (instituteId: string, phone: string | null, email: string | null) => {
      let data: any;
      if (instituteId) {
        if (phone) {
          data = {
            id: instituteId,
            phone: phone,
          };
          dispatch<any>(getLeadListByInstituteAndContact(data));
        } else if (email) {
          data = {
            id: instituteId,
            email: email,
          };
          dispatch<any>(getLeadListByInstituteAndContact(data));
        }
      }
    },
    [getLeadListByInstituteAndContact]
  );

  const openCancelPopupBeforeActivating = () => {
    setCancelPopupBeforeActivating(true);
  };

  const closeCancelPopupBeforeActivating = () => {
    setCancelPopupBeforeActivating(false);
  };

  const cancelConfirmBeforeActivating = () => {
    setCancelPopupBeforeActivating(false);
    const body = {
      enquiryId: leadById?.id,
    };
    dispatch<any>(cancelEnach(body));
  };

  const resendBeforeActivating = () => {
    const body = {
      enquiryId: leadById?.id,
    };
    dispatch<any>(resendEnach(body));
  };

  const copyEnachLinkSumit = () => {
    const body = {
      enquiryId: leadById?.id,
    };
    dispatch<any>(copyEnachLinkHit(body));
  };

  return (
    <div className={styles.enachContiner}>
      {leadById?.autoDebit !== undefined ? (
        <div>
          <div className={styles.enachContiner}>
            {leadById?.autoDebitType === "UPI" ||
            leadById?.autoDebitType === undefined ? (
              <div>
                <div
                  className={
                    leadById?.autoDebit === "DISABLED" ||
                    leadById?.autoDebit === "ENABLED"
                      ? styles.buttonEnabled
                      : styles.buttonDisabled
                  }
                  onClick={
                    leadById?.autoDebit === "ENABLED" ||
                    leadById?.autoDebit === "UNDER_PROCESSING"
                      ? () => {}
                      : handleSubmit
                  }
                  style={{ width: "150px" }}
                >
                  {leadById?.autoDebit === "ENABLED"
                    ? "Easy EMI's Activated"
                    : "Activate Easy EMI's"}
                </div>
              </div>
            ) : (
              <div>
                <div
                  className={
                    leadById?.autoDebit === "DISABLED" ||
                    leadById?.autoDebit === "ENABLED"
                      ? styles.buttonEnabled
                      : styles.buttonDisabled
                  }
                  onClick={
                    leadById?.autoDebit === "ENABLED" ||
                    leadById?.autoDebit === "UNDER_PROCESSING"
                      ? () => {}
                      : handleSubmit
                  }
                  style={{ width: "150px" }}
                >
                  {"Activate Easy EMI's"}
                </div>
              </div>
            )}
            <div className={styles.statusContainer}>
              <div className={styles.statusHeader}>Status : </div>
              {leadById?.autoDebitType === "ENACH" ||
              leadById?.autoDebitType === undefined ? (
                <div
                  className={
                    leadById?.autoDebit === "UNDER_PROCESSING"
                      ? styles.requestTitle
                      : leadById?.autoDebit === "DISABLED"
                      ? styles.statusTitle
                      : styles.activatedTitle
                  }
                >
                  {leadById?.autoDebit === "UNDER_PROCESSING"
                    ? "Request Raised"
                    : leadById?.autoDebit === "DISABLED"
                    ? "Not Activated"
                    : "Activated"}
                </div>
              ) : (
                <div className={styles.statusTitle}>{"Not Activated"}</div>
              )}
              {(leadById?.autoDebitType === "ENACH" ||
                leadById?.autoDebitType === undefined) && (
                <>
                  {leadById?.autoDebit === "ENABLED" && (
                    <div>
                      <Tooltip
                        arrow
                        title={""}
                        PopperProps={{ style: { zIndex: 9999999 } }}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#101828",
                              color: "#fff",
                              fontSize: "12px",
                              fontWeight: "500",
                              padding: "8px 12px",
                              zIndex: "9999999",
                              "& .MuiTooltip-arrow": {
                                color: "#101828",
                                zIndex: "9999999",
                              },
                            },
                          },
                        }}
                      >
                        <span>
                          <IconButton
                            aria-label="more"
                            id="long-button"
                            aria-controls={open ? "long-menu" : undefined}
                            aria-expanded={open ? "true" : undefined}
                            aria-haspopup="true"
                            onClick={handleCancelOpen}
                            sx={{
                              width: "20px",
                              height: "20px",
                              border: "none",
                              borderRadius: "4PX",
                              background: "trasnarent",
                              "&:hover": {
                                background: "transparent",
                              },
                            }}
                          >
                            <img src={dots} alt="" />
                          </IconButton>
                        </span>
                      </Tooltip>

                      <Popover
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCancelClose}
                        sx={{ zIndex: 99999999 }}
                        PaperProps={{
                          style: {
                            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                            borderRadius: "4PX",
                            border: "1px solid #E4E4E7",
                            zIndex: 99999999,
                          },
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: -5,
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          sx={{
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#EC3939",
                          }}
                          onClick={() => {
                            handleCancelClose();
                            openCancelPopup();
                          }}
                        >
                          Cancel Easy EMI's
                        </MenuItem>
                      </Popover>
                    </div>
                  )}

                  {leadById?.autoDebit === "UNDER_PROCESSING" && (
                    <div>
                      <Tooltip
                        arrow
                        title={""}
                        PopperProps={{ style: { zIndex: 9999999 } }}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#101828",
                              color: "#fff",
                              fontSize: "12px",
                              fontWeight: "500",
                              padding: "8px 12px",
                              zIndex: "9999999",
                              "& .MuiTooltip-arrow": {
                                color: "#101828",
                                zIndex: "9999999",
                              },
                            },
                          },
                        }}
                      >
                        <span>
                          <IconButton
                            aria-label="more"
                            id="long-button"
                            aria-controls={open ? "long-menu" : undefined}
                            aria-expanded={open ? "true" : undefined}
                            aria-haspopup="true"
                            onClick={handleCancelOpen}
                            sx={{
                              width: "20px",
                              height: "20px",
                              border: "none",
                              borderRadius: "4PX",
                              background: "trasnarent",
                              "&:hover": {
                                background: "transparent",
                              },
                            }}
                          >
                            <img src={dots} alt="" />
                          </IconButton>
                        </span>
                      </Tooltip>

                      <Popover
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCancelClose}
                        sx={{ zIndex: 99999999 }}
                        PaperProps={{
                          style: {
                            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                            borderRadius: "4PX",
                            border: "1px solid #E4E4E7",
                            zIndex: 99999999,
                          },
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: -5,
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          sx={{
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "rgba(29, 86, 207, 0.8)",
                          }}
                          onClick={() => {
                            handleCancelClose();
                            copyEnachLinkSumit();
                          }}
                        >
                          Copy Link
                        </MenuItem>
                        <MenuItem
                          sx={{
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#EC3939",
                          }}
                          onClick={() => {
                            handleCancelClose();
                            openCancelPopupBeforeActivating();
                          }}
                        >
                          Cancel Easy EMI's Link
                        </MenuItem>
                        <MenuItem
                          sx={{
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "rgba(29, 86, 207, 0.8)",
                          }}
                          onClick={() => {
                            handleCancelClose();
                            resendBeforeActivating();
                          }}
                        >
                          Resend Easy EMI's Link
                        </MenuItem>
                      </Popover>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {leadById?.autoDebit === "DISABLED" && (
            <div
              style={{
                color: "rgba(20, 44, 68, 1)",
                fontSize: "10px",
                marginTop: "5px",
              }}
            >
              To activate Easy EMI's, please make sure the student email is
              added
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className={styles.enachContiner}>
            <div>
              <div
                className={styles.buttonEnabled}
                onClick={handleSubmit}
                style={{ width: "150px" }}
              >
                {"Activate Easy EMI's"}
              </div>
            </div>
            <div className={styles.statusContainer}>
              <div className={styles.statusHeader}>Status : </div>
              <div className={styles.statusTitle}>{"Not Activated"}</div>
              {leadById?.autoDebit === "ENABLED" && (
                <div>
                  <Tooltip
                    arrow
                    title={""}
                    PopperProps={{ style: { zIndex: 9999999 } }}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#101828",
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: "500",
                          padding: "8px 12px",
                          zIndex: "9999999",
                          "& .MuiTooltip-arrow": {
                            color: "#101828",
                            zIndex: "9999999",
                          },
                        },
                      },
                    }}
                  >
                    <span>
                      <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={handleCancelOpen}
                        sx={{
                          width: "20px",
                          height: "20px",
                          border: "none",
                          borderRadius: "4PX",
                          background: "trasnarent",
                          "&:hover": {
                            background: "transparent",
                          },
                        }}
                      >
                        <img src={dots} alt="" />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Popover
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleCancelClose}
                    sx={{ zIndex: 99999999 }}
                    PaperProps={{
                      style: {
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                        borderRadius: "4PX",
                        border: "1px solid #E4E4E7",
                        zIndex: 99999999,
                      },
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: -5,
                      horizontal: "right",
                    }}
                  >
                    <MenuItem
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#EC3939",
                      }}
                      onClick={() => {
                        handleCancelClose();
                        openCancelPopup();
                      }}
                    >
                      Cancel Easy EMI's
                    </MenuItem>
                  </Popover>
                </div>
              )}

              {leadById?.autoDebit === "UNDER_PROCESSING" && (
                <div>
                  <Tooltip
                    arrow
                    title={""}
                    PopperProps={{ style: { zIndex: 9999999 } }}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#101828",
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: "500",
                          padding: "8px 12px",
                          zIndex: "9999999",
                          "& .MuiTooltip-arrow": {
                            color: "#101828",
                            zIndex: "9999999",
                          },
                        },
                      },
                    }}
                  >
                    <span>
                      <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={handleCancelOpen}
                        sx={{
                          width: "20px",
                          height: "20px",
                          border: "none",
                          borderRadius: "4PX",
                          background: "trasnarent",
                          "&:hover": {
                            background: "transparent",
                          },
                        }}
                      >
                        <img src={dots} alt="" />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Popover
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleCancelClose}
                    sx={{ zIndex: 99999999 }}
                    PaperProps={{
                      style: {
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                        borderRadius: "4PX",
                        border: "1px solid #E4E4E7",
                        zIndex: 99999999,
                      },
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: -5,
                      horizontal: "right",
                    }}
                  >
                    <MenuItem
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "rgba(29, 86, 207, 0.8)",
                      }}
                      onClick={() => {
                        handleCancelClose();
                        copyEnachLinkSumit();
                      }}
                    >
                      Copy Link
                    </MenuItem>

                    <MenuItem
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#EC3939",
                      }}
                      onClick={() => {
                        handleCancelClose();
                        openCancelPopupBeforeActivating();
                      }}
                    >
                      Cancel Easy EMI's Link
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "rgba(29, 86, 207, 0.8)",
                      }}
                      onClick={() => {
                        handleCancelClose();
                        resendBeforeActivating();
                      }}
                    >
                      Resend Easy EMI's Link
                    </MenuItem>
                  </Popover>
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              color: "rgba(20, 44, 68, 1)",
              fontSize: "10px",
              marginTop: "5px",
            }}
          >
            To activate Easy EMI's, please make sure the student email is added
          </div>
        </div>
      )}
      <CancelPaymentLinkPopup
        open={cancelPopup}
        onClose={closeCancelPopup}
        noButtonClick={closeCancelPopup}
        yesButtonClick={cancelConfirm}
      />
      <CancelPaymentLinkPopup
        open={cancelPopupBeforeActivating}
        onClose={closeCancelPopupBeforeActivating}
        noButtonClick={closeCancelPopupBeforeActivating}
        yesButtonClick={cancelConfirmBeforeActivating}
      />
      <EnachConfirmPopup
        openEnachPopup={openEnachPopup}
        setOpenEnachPopup={setOpenEnachPopup}
        leadById={leadById}
      />
    </div>
  );
};

export default ENach;
